import { StandardButton } from "../../atoms/buttons";
import { Spinner } from "../../atoms/spinner";
import { icon } from "../../functions/icons";
import { VerticalLayout } from "../layout";
import ElearningFeed from "../tap-to-learn/ElearningFeed";
import TapToLearn from "../tap-to-learn/TapToLearn";
import AssessmentFinished, { AssessmentFinishedTap } from "./AssessmentFinished";
import AssessmentPage from "./AssessmentPage";
import AssessmentStart from "./AssessmentStart";

export default function HandleAssessment({
  embedPage,
  elearningInformation,
  embedBtnState,
  startEmbedAssessment,
  switchPage,
  triggerConfetti,
  id,
  embedStructure,
  setEmbedStructure,
  setCurrentAssessment,
  setFinished,
  interactionEmbed,
  elearningFeedData = [],
  code
}) {
  switch (embedPage) {
    case "loading":
      return (
        <VerticalLayout>
          <Spinner color="grey-100" size="4rem" />
        </VerticalLayout>
      );

    case "not_found":
      return (
        <EmbedError
          iconType="link-off"
          errorTitle="Ongeldige embed"
          message="Controleer de URL die u probeert te embedden of neem contact op met de beheerder."
        />
      );

    case "start":
      return (
        <AssessmentStart
          elearningInformation={elearningInformation}
          embedBtnState={embedBtnState}
          startEmbedAssessment={startEmbedAssessment}
        />
      );

    case "assessment":
      return (
        <AssessmentPage
          interactionEmbed={interactionEmbed}
          elearningInformation={elearningInformation}
          embedStructure={embedStructure}
          setEmbedStructure={setEmbedStructure}
          setFinished={setFinished}
          id={id}
        />)

    case "finished":
      return (
        <AssessmentFinished
          elearningInformation={elearningInformation}
          id={id}
        />
      )
    case "finished_tap_to_learn":
      return (
        <AssessmentFinishedTap
          goBack={() => switchPage("tap-to-learn-feed")}
          elearningInformation={elearningInformation}
          triggerConfetti={triggerConfetti}
          id={id}
          code={code}
        />
      )
    case "tap-to-learn-feed":
      return <ElearningFeed elearningFeedData={elearningFeedData} startEmbedAssessmentNow={startEmbedAssessment} setCurrentAssessment={setCurrentAssessment} />

    default:
      return null;
  }
}

const EmbedError = ({ iconType, errorTitle, message }) => (
  <VerticalLayout className="center-all complete-height embed-error-box">
    <span
      className="small-standard-margin"
      style={{ color: "var(--grey-500)" }}
    >
      {icon(iconType, 96)}
    </span>
    <span
      style={{
        color: "var(--grey-300)",
        textAlign: "center",
        fontSize: "1.5rem",
        fontWeight: 600,
        margin: "0.5rem 0px",
      }}
    >
      {errorTitle}
    </span>
    {message && (
      <span
        style={{
          color: "var(--grey-500)",
          textAlign: "center",
          margin: "0px 2rem",
          fontSize: "14px",
        }}
      >
        {message}
      </span>
    )}
    <StandardButton
      onClick={() => window.open("https://expligo.nl/", "_blank")?.focus()}
      style={{ background: "#374e68", marginTop: "3rem" }}
      size="large"
    >
      Ontdek Expligo{" "}
      <span style={{ marginLeft: "0.5rem" }}>{icon("open-url")}</span>
    </StandardButton>
  </VerticalLayout>
);
